<template>
  <v-text-field
    ref="form"
    class="ml-4"
    append-icon="search"
    label="Search"
    v-model="search"
    clearable
    hide-details
  ></v-text-field>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      timeOut: null
    };
  },
  computed: {
    search: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.$emit("search", value);
        }, 500);
      }
    }
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
